import { selectorFamily } from 'recoil';
export const genericFieldValidationSelectorFamily = selectorFamily({
    key: 'validation/generic/field',
    get: ({ componentValidation = {}, value }) => () => {
        // !value to also catch empty strings -> booleans are handled separately anyway
        const empty = !value || value === null || value === undefined;
        if (componentValidation.required) {
            return { valid: !empty, errors: empty ? ['required'] : [], empty };
        }
        return { valid: true, errors: [], empty };
    },
});
